/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_Q_Otomatik_OnaylamaInputs */

const tr_faq_q_otomatik_onaylama = /** @type {(inputs: Faq_Q_Otomatik_OnaylamaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Otomatik onaylama nasıl açılır?`)
};

const en_faq_q_otomatik_onaylama = /** @type {(inputs: Faq_Q_Otomatik_OnaylamaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How do I enable auto-approval?`)
};

const de_faq_q_otomatik_onaylama = /** @type {(inputs: Faq_Q_Otomatik_OnaylamaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie aktiviere ich die automatische Genehmigung?`)
};

const ru_faq_q_otomatik_onaylama = /** @type {(inputs: Faq_Q_Otomatik_OnaylamaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Как включить автоматическое одобрение?`)
};

/**
* | output |
* | --- |
* | "How do I enable auto-approval?" |
*
* @param {Faq_Q_Otomatik_OnaylamaInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const faq_q_otomatik_onaylama = /** @type {((inputs?: Faq_Q_Otomatik_OnaylamaInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_Q_Otomatik_OnaylamaInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_faq_q_otomatik_onaylama(inputs)
	if (locale === "de") return de_faq_q_otomatik_onaylama(inputs)
	if (locale === "ru") return ru_faq_q_otomatik_onaylama(inputs)
	return tr_faq_q_otomatik_onaylama(inputs)
});